/* eslint-disable no-return-assign */
import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import * as actions from '../actions';
import * as c from '../constant';

function ViewSOA({ data, onRevoke, isRevoking, getItem, getReportAccess }) {
  const setModal = useContext(ModalContext);
  const [printOriginal, setPrintOriginal] = useState(0);
  const [iframeKey, setIframeKey] = useState(1);
  const permissions = getJson('permissions');
  const [remarks, setRemarks] = useState('');
  const [revoke, setRevoke] = useState('');
  const [src, setSrc] = useState('');
  const authProfile = getJson('profile') || {};

  useEffect(() => {
    const args = {
      path: c.BPLS_E2E_EPERMIT_URL.replace('{id}', _.get(data, 'id')),
      email: _.get(authProfile, 'email'),
      is_original: printOriginal,
      output: 'I',
    };
    getReportAccess(args, (response) => {
      setSrc(response?.res?.res?.url || '');
    });
  }, []);

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };


  useEffect(() => {
    setIframeKey(_.random(1, 1000));
  }, [printOriginal]);

  const viewOriginal = e => {
    e.preventDefault();

    setPrintOriginal(!printOriginal ? 1 : 0);
  };

  const onSubmitRevoke = e => {
    e.preventDefault();
    const args = {
      remarks,
    };

    onRevoke(_.get(data, 'id'), args, response => {
      const isRevoke = _.get(
        response,
        'res.res.included.1.attributes.is_revoked'
      );

      setRevoke(isRevoke);
      getItem(_.get(data, 'id'));
    });
  };

  useEffect(() => {
    setRemarks('');

    setIframeKey(_.random(1, 1000));
  }, [revoke]);

  useEffect(() => {
    setRevoke(
      !_.get(data, 'included.bplsApplication.attributes.is_revoked') ? 0 : 1
    );
  }, [_.get(data, 'included.bplsApplication.attributes.is_revoked')]);

  return (
    <Modal.Body>
      <form>
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12">
                <iframe
                  key={iframeKey}
                  style={{ width: '100%', height: 600, border: 'none' }}
                  title="Permit"
                  src={src || ''}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          {!revoke ? (
            <>
              {Acl(permissions, ['E2E BPLS REVOKE PERMIT']) && (
                <>
                  <input
                    className="form-control w-50"
                    placeholder="Revoke Remarks..."
                    value={remarks}
                    onChange={e => setRemarks(e.target.value)}
                  />
                  &nbsp;
                  <button
                    disabled={isRevoking || !remarks}
                    type="button"
                    onClick={onSubmitRevoke}
                    className="btn btn-danger "
                  >
                    <span className="font-weight-bold">Revoke</span>
                  </button>
                  &nbsp;
                </>
              )}
            </>
          ) : (
            <>
              {Acl(permissions, ['E2E BPLS REVOKE PERMIT']) && (
                <>
                  <input
                    className="form-control w-50"
                    placeholder="Unrevoke Remarks..."
                    value={remarks}
                    onChange={e => setRemarks(e.target.value)}
                  />
                  &nbsp;
                  <button
                    disabled={isRevoking || !remarks}
                    type="button"
                    onClick={onSubmitRevoke}
                    className="btn btn-danger "
                  >
                    <span className="font-weight-bold">Unrevoke</span>
                  </button>
                  &nbsp;
                </>
              )}
            </>
          )}
          {Acl(permissions, ['E2E BPLS ORIGINAL PERMIT']) && (
            <button
              type="button"
              onClick={viewOriginal}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mx-2   "
              disabled={revoke}
            >
              {printOriginal ? 'Digital Copy' : 'Original Copy'}
            </button>
          )}
          <button type="button" onClick={closeModal} className="btn btn-dark ">
            <span className="font-weight-bold">Close</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

ViewSOA.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onRevoke: PropTypes.instanceOf(Function).isRequired,
  isRevoking: PropTypes.bool.isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  getReportAccess: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  isRevoking: _.get(api, 'loading', []).indexOf(c.REVOKE_PERMIT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewSOA);
